var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('span',[(_vm.direction === 'asc')?_c('font-awesome-icon',{attrs:{"icon":("sort-" + _vm.type + "-down")}}):_c('font-awesome-icon',{attrs:{"icon":("sort-" + _vm.type + "-up")}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }